import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material'
import {
  Info,
  Edit,
  Flag,
  FlagOutlined,
  History,
  FileDownload,
  ContentCopy,
} from '@mui/icons-material'

const MENU_ITEMS = [
  { key: 'details', icon: Info, label: 'View item details' },
  { key: 'edit', icon: Edit, label: 'Edit scheduled production' },
  { key: 'divider1' },
  { key: 'flag', icon: Flag, label: 'Flag for review' },
  { key: 'unflag', icon: FlagOutlined, label: 'Unflag' },
  { key: 'divider2' },
  { key: 'history', icon: History, label: 'View override history' },
  { key: 'export', icon: FileDownload, label: 'Export this item' },
  { key: 'copy', icon: ContentCopy, label: 'Copy item number' },
]

export default function ContextMenu({ anchorPosition, open, onClose, onAction, rowData }) {
  const handleAction = (key) => {
    if (key === 'copy' && rowData?.itemNumber) {
      navigator.clipboard?.writeText(rowData.itemNumber)
    }
    onAction?.(key, rowData)
    onClose()
  }

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      slotProps={{
        paper: {
          sx: {
            minWidth: 220,
            borderRadius: 2,
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          },
        },
      }}
    >
      {MENU_ITEMS.map((item) => {
        if (item.key.startsWith('divider')) {
          return <Divider key={item.key} />
        }
        const Icon = item.icon
        return (
          <MenuItem
            key={item.key}
            onClick={() => handleAction(item.key)}
            sx={{ py: 0.75, fontSize: '0.8125rem' }}
          >
            <ListItemIcon>
              <Icon sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ fontSize: '0.8125rem' }}
            />
          </MenuItem>
        )
      })}
    </Menu>
  )
}
